export default __webpack_public_path__ + "static/work-remotely-4f86c96bccc45566249313055c7a1a7a.gif";